import FilterNav from '../../molecules/filterNav/FilterNav';
import styles from './SearchItemContainer.module.scss';
import BoxContainer from '../../molecules/boxContainer/BoxContainer';
import PropTypes from 'prop-types';

const SearchItemContainer = (props) => {

	return (
		<div className={styles.navGutter}>
			<FilterNav
				headingName='Accessories'
				backbtn={props.hideAccessories}
				resetClickHandler={props.resetClickHandler} 
				selectedFilter={props.selectedFilter}
			/>
			{props.accessoriesMob.map((promo) => (
				<BoxContainer key={promo.id} boxHeading={promo.label} selected={props.isAccessoriesChecked(promo)} 
				selectHandler={(flag) => props.accessoriesClickHandler(flag, promo)}/>
			))}
		</div>
	);
};

SearchItemContainer.propTypes = {
	hideAccessories: PropTypes.bool,
	resetClickHandler: PropTypes.bool,
	accessoriesMob: PropTypes.array,
	isAccessoriesChecked: PropTypes.any,
	accessoriesClickHandler: PropTypes.func,
	selectedFilter:PropTypes.object
};

export default SearchItemContainer;
